import {COLLECTION_USER} from '../users/constants';
import {SUBCOLLECTION_PROGRESS} from './constants';

/**
 * Path to the progress subcollection for a user.
 * Documents are keyed by examModuleId.
 */
export function getProgressCollectionPath(uid: string): string {
  return `${COLLECTION_USER}/${uid}/${SUBCOLLECTION_PROGRESS}`;
}
